var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 8.16667V4.83333C3.6665 3.94928 4.01769 3.10143 4.64281 2.47631C5.26794 1.85119 6.11578 1.5 6.99984 1.5C7.88389 1.5 8.73174 1.85119 9.35686 2.47631C9.98198 3.10143 10.3332 3.94928 10.3332 4.83333V8.16667M1.1665 9.83333C1.1665 9.39131 1.3421 8.96738 1.65466 8.65482C1.96722 8.34226 2.39114 8.16667 2.83317 8.16667H11.1665C11.6085 8.16667 12.0325 8.34226 12.345 8.65482C12.6576 8.96738 12.8332 9.39131 12.8332 9.83333V14.8333C12.8332 15.2754 12.6576 15.6993 12.345 16.0118C12.0325 16.3244 11.6085 16.5 11.1665 16.5H2.83317C2.39114 16.5 1.96722 16.3244 1.65466 16.0118C1.3421 15.6993 1.1665 15.2754 1.1665 14.8333V9.83333ZM6.1665 12.3333C6.1665 12.5543 6.2543 12.7663 6.41058 12.9226C6.56686 13.0789 6.77882 13.1667 6.99984 13.1667C7.22085 13.1667 7.43281 13.0789 7.58909 12.9226C7.74537 12.7663 7.83317 12.5543 7.83317 12.3333C7.83317 12.1123 7.74537 11.9004 7.58909 11.7441C7.43281 11.5878 7.22085 11.5 6.99984 11.5C6.77882 11.5 6.56686 11.5878 6.41058 11.7441C6.2543 11.9004 6.1665 12.1123 6.1665 12.3333Z",
    stroke: "#697586",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.90f91f511b6cb8ec2c7fe0bd627c2dfb.svg";
export { ForwardRef as ReactComponent };